import {breakpoints} from '@wix/document-services-implementation'
import type {PublicMethodUtils} from '@wix/document-services-types'
import type {BreakpointsPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<BreakpointsPublicAPI> {
    return {
        // @ts-expect-error BUG: initMethod is not defined in breakpoints
        initMethod: breakpoints.init,
        methods: {
            breakpoints: {
                update: publicMethodUtils.defineDataManipulationAction(breakpoints.update),
                get: publicMethodUtils.defineGetter(breakpoints.get),
                remove: publicMethodUtils.defineDataManipulationAction(breakpoints.remove),
                wasBreakpointsMigratedToVariants: publicMethodUtils.defineGetter(
                    breakpoints.wasBreakpointsMigratedToVariants
                )
            }
        }
    }
}
